import { httpCreate } from './http';

const http = httpCreate('/srv/official-account');

/* 企业版新增 */
export const officialAccount = {
	//保存公众号信息
	saveOfficialAccount(data) {
		return http.post('', data);
	},
	//微信支付设置
	saveOfficialPayAccount(data) {
		return http.post('', data);
	},
	// 上传证书
	upload(data) {
		return http.post('/upload', data);
	},
};
